import React, { forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import SearchIcon from "@mui/icons-material/Search";

import { TextField, Grid } from "@mui/material";
import { ButtonsWrapper, StyledForm } from "./styled";

import { getRequiredField } from "helpers/formValidations";
import { APARTMENTS_CONFIG, APARTMENTS_PHRASE } from "./config";

import RegularButton from "components/CustomButtons/Button";
import AutocompleteControlled from "components/AutocompleteControlled/AutocompleteControlled";
import {
  fetchEditApartment,
  fetchCustomers
} from "redux/actions/buildings/apartments/apartmentsActions";

const ApartmentsSchema = Yup.object({
  [APARTMENTS_CONFIG.customer.key]: Yup.object().required(
    getRequiredField(APARTMENTS_CONFIG.customer.label)
  ),
  [APARTMENTS_CONFIG.phone.key]: Yup.string().required(
    getRequiredField(APARTMENTS_CONFIG.phone.label)
  )
});

export const AssignCustomerForm = forwardRef(props => {
  const dispatch = useDispatch();
  const { handleClose } = props;
  const { editApartment, customerList, idStation } = useSelector(
    state => state.apartments
  );
  const { isLoadingComp } = useSelector(({ search }) => search);

  const {
    reset,
    register,
    handleSubmit,
    getValues,
    control,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(ApartmentsSchema)
  });

  const handleCloseForm = () => {
    handleClose();
    reset();
  };

  const onSubmit = React.useCallback(
    formData => {
      // You can use the validated data to make your API request here
      const body = {
        idCustomer: formData[APARTMENTS_CONFIG.customer.key]?.id
      };

      dispatch(fetchEditApartment(body, editApartment.id));
      handleCloseForm();
    },
    [editApartment]
  );

  const handleSearch = () => {
    const phone = getValues([APARTMENTS_CONFIG.phone.key])[0];
    dispatch(fetchCustomers(idStation, phone));
  };

  return (
    <>
      <StyledForm component="form" fullWidth onSubmit={handleSubmit(onSubmit)}>
        <Grid container >
          <Grid item xs={12} sm={10}>
            <TextField
              size="small"
              fullWidth
              type="text"
              label={APARTMENTS_CONFIG.phone.label}
              variant="outlined"
              error={!!errors[APARTMENTS_CONFIG.phone.key]}
              helperText={errors[APARTMENTS_CONFIG.phone.key]?.message}
              {...register(APARTMENTS_CONFIG.phone.key)}
            />
          </Grid>
          <Grid item xs={12} sm={2} container alignItems="center" justifyContent="center">
            <RegularButton
              justIcon
              round
              color="info"
              size="sm"
              tooltip="Nuevo Cliente"
              onClick={handleSearch}
              loading={isLoadingComp?.fetchCustomers}
            >
              <SearchIcon style={{ margin: 0 }} />
            </RegularButton>
          </Grid>
          <Grid item xs={12} style={{ marginTop: 16 }}>
            {customerList ? (
              <AutocompleteControlled
                name={APARTMENTS_CONFIG.customer.key}
                label={APARTMENTS_CONFIG.customer.label}
                options={customerList}
                control={control}
              />
            ) : (
              "Favor de ingresar el teléfono del cliente (10 dígitos)"
            )}
          </Grid>
        </Grid>
        <ButtonsWrapper>
          <RegularButton
            variant="contained"
            color="danger"
            onClick={handleCloseForm}
          >
            {APARTMENTS_PHRASE.meterModal.actions.cancel}
          </RegularButton>
          <RegularButton
            variant="contained"
            type="submit"
            color="info"
          >
            {APARTMENTS_PHRASE.meterModal.actions.assign}
          </RegularButton>
        </ButtonsWrapper>
      </StyledForm>
    </>
  );
});
